import React from 'react';
import { color, radius, space, shadow } from '../tokens';

interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  /** Adds an interactive cursor affordance when the card is tappable. */
  interactive?: boolean;
  raised?: boolean;
  padding?: number;
}

/**
 * Generic surface card for objects and results. Token-driven so it adapts to
 * the Telegram light/dark theme.
 */
export default function Card({ children, interactive, raised, padding = space.lg, style, ...rest }: CardProps) {
  const s: React.CSSProperties = {
    background: color.surface,
    border: `1px solid ${color.border}`,
    borderRadius: radius.lg,
    padding,
    boxShadow: raised ? shadow.sm : undefined,
    cursor: interactive ? 'pointer' : undefined,
    WebkitTapHighlightColor: 'transparent',
    boxSizing: 'border-box',
    width: '100%',
    ...style,
  };
  return (
    <div {...rest} style={s}>
      {children}
    </div>
  );
}
